// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__31OX9","title":"InfoRow_title__2fuD_"};